// extracted by mini-css-extract-plugin
export default {"container":"Teams_container__JMxXF","odds":"Teams_odds__J1FUV","oddsbutton":"Teams_oddsbutton__x9qWV"};